export const networkOnly = { requestPolicy: 'network-only' as const };

export const networkOnlyWithSignal = (signal?: AbortSignal) =>
  signal
    ? { ...networkOnly, fetchOptions: { signal } as RequestInit }
    : networkOnly;
